<template>
  <div class="radio">
    <div class="radio__groups">
      <div class="radio__group">
        <input
          type="radio"
          class="radio__inputs"
          value="Staff Augmentation"
          name="radio-input"
          @click="selectedRadio"
          checked
        />
        <span class="checkmark"></span>
        <label for="sa">Staff <br />Augmentation</label>
      </div>

      <div class="radio__group">
        <input
          type="radio"
          class="radio__inputs"
          value="Managed Teams"
          name="radio-input"
          @click="selectedRadio"
        />
        <span class="checkmark"></span>
        <label for="mt">Managed<br />Teams</label>
      </div>
      <div class="radio__group">
        <input
          type="radio"
          class="radio__inputs"
          value="Product Engineering"
          name="radio-input"
          @click="selectedRadio"
        />
        <span class="checkmark"></span>
        <label for="pe">Product<br />Engineering</label>
      </div>
      <div class="radio__group">
        <input
          type="radio"
          class="radio__inputs"
          value="Other"
          name="radio-input"
          @click="selectedRadio"
        />
        <span class="checkmark"></span>
        <label for="other">Got special <br />requests?</label>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  methods: {
    selectedRadio(e) {
      document.querySelectorAll('.radio__group').forEach(v => {
        v.style.border = '1px solid #d8d8d8';
        v.removeAttribute('checked');
      });
      e.target.setAttribute('checked', 'checked');
      e.target.parentElement.style.border = '2px solid #f05a28';
      this.$emit('readyToSubmit');
    }
  }
};
</script>

<style lang="scss" scoped>
.radio {
  &__groups {
    display: flex;
    flex-direction: column;
  }
  &__group {
    position: relative;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    padding: 1.6rem;
    height: 7.4rem;
    border: 1px solid $border-gray;
    border-radius: 0.5rem;
    cursor: pointer;
    &:first-child,
    &:hover {
      border: 2px solid $primary;
    }
    &:not(:last-child) {
      margin-bottom: 1.5rem;
    }
    & input:checked ~ .checkmark {
      background-color: $primary;
      border-color: $primary;
    }
    & input:checked ~ .checkmark:after {
      display: block;
    }
    & .checkmark:after {
      left: 7px;
      top: 3px;
      width: 5px;
      height: 10px;
      border: solid white;
      border-width: 0 3px 3px 0;
      -webkit-transform: rotate(45deg);
      -ms-transform: rotate(45deg);
      transform: rotate(45deg);
    }
  }
  &__inputs {
    position: absolute;
    opacity: 0;
    cursor: pointer;
    height: 100%;
    width: 100%;
    z-index: 1;
  }
  label {
    position: absolute;
    color: $text-light-gray;
    font-family: Roboto;
    font-size: 2rem;
    font-weight: 500;
    letter-spacing: -0.2rem;
    line-height: 2rem;
    left: 25%;
    @include mq-max(450px) {
      left: 27%;
      font-size: 1.6rem;
      letter-spacing: -0.1rem;
    }
  }
  .checkmark {
    position: absolute;
    top: 50%;
    left: 10%;
    height: 25px;
    width: 25px;
    border-radius: 50%;
    border: 2px solid $text-light-gray;
    background-color: transparent;
    transform: translateY(-50%);
    &:after {
      content: '';
      position: absolute;
      display: none;
    }
    @include mq-max(450px) {
      left: 5%;
    }
  }
}
.checkmark:checked ~ {
  border: 2px solid $primary;
}
</style>
